<div class="modal-body">
  <form [formGroup]="securityCodeForm" class="clrsgn-form">
    <div class="row">
      <div class="col">
        <mat-form-field appearance="fill" class="clrsgn-form-field">
          <mat-label>Verification Method</mat-label>
          <input
            [matAutocomplete]="autocompleteVerificationType"
            aria-label="Verification Method"
            formControlName="verificationType"
            matInput
            type="text"
            />
            <mat-autocomplete
              #autocompleteVerificationType="matAutocomplete"
              >
              @for (verificationType of verificationTypes; track verificationType) {
                <mat-option
                  (click)='onDropdownChange($event)'
                  [value]="verificationType"
                  >
                  {{ verificationType }}
                </mat-option>
              }
            </mat-autocomplete>
            <app-form-error
              [controlName]="'verificationType'"
              [group]="securityCodeForm"
            ></app-form-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row marginTopTenPx">
        <div class="col">
          <mat-form-field appearance="fill" class="clrsgn-form-field">
            <mat-label for="securityCode" class="clrsgn-label">
              Security Code
            </mat-label>
            <input
              matInput
              maxlength="4"
              type="text"
              formControlName="securityCode"
              id="securityCode"
              />
              <app-form-error
                [group]="securityCodeForm"
                [controlName]="'securityCode'"
              ></app-form-error>
            </mat-form-field>
          </div>
        </div>

      </form>
    </div>
    <div class="modal-footer">
      <button
        id="cancelButton"
        type="button"
        class="btn-secondary"
        data-bs-dismiss="modal"
        (click)="resetModal('cancel')"
        >
        Cancel
      </button>
      <button
        id="saveParticipant"
        type="button"
        class="btn-primary"
        data-bs-dismiss="modal"
        (click)="patchVerification()"
        >
        Save Participant
      </button>
    </div>
